import { useQuery } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import EudrDashboardService from 'src/modules/3rd-party-management/apis/admin/EudrDashboardService';

export const EUDR_UPCOMING_SHIPMENTS_MISSING_DDS_QUERY_KEY = '3rd-party-management-fetch-eudr-upcoming-shipments-missing-dds';

const useUpcomingShipmentsMissingDds = ({
    t,
}) => {
    return useQuery({
        queryKey: [EUDR_UPCOMING_SHIPMENTS_MISSING_DDS_QUERY_KEY],
        queryFn: async () => {
            const service = EudrDashboardService.getInstance();

            return await service.fetchUpcomingShipmentsMissingDds();
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        onError: (error) => {
            if (process.env.NODE_ENV === 'development') console.error(error);

            toast(t('An error occurred while fetching EUDR upcoming shipments missing DDS data.'), {
                type: 'error',
            });
        },
    });
};

export default useUpcomingShipmentsMissingDds;
